import React from "react";
import difference from "lodash/difference";
import { useGetProjectActorByOxygenId } from "../../../hooks/useGetProjectActorByOxygenId";
import { ActivityLogCardProps } from "../activityLogTypes";
import {
  MultiUserChangeActivityCard,
  ActivityMultiUserChange,
} from "@adsk/alloy-react-activity-log";
import { Company, Role, User } from "@adsk/alloy-provider";
type MemberType = User | Role | Company;

export const ChangedWatcherActivityCard = ({
  activityChange,
  isAggregated,
  ...props
}: ActivityLogCardProps) => {
  const getProjectMember = useGetProjectActorByOxygenId();
  let addedWatchers: MemberType[] = [],
    removedWatchers: MemberType[] = [];
  const { before, after } = activityChange;

  try {
    const beforeUserIds = (JSON.parse(before) as string[]) || [];
    const afterUserIds = (JSON.parse(after) as string[]) || [];
    addedWatchers = difference(afterUserIds, beforeUserIds)
      .map((id: string) => getProjectMember(id))
      .filter((member): member is MemberType => !!member);
    removedWatchers = difference(beforeUserIds, afterUserIds)
      .map((id: string) => getProjectMember(id))
      .filter((member): member is MemberType => !!member);
  } catch (e: any) {
    console.error(e);
  }

  return isAggregated ? (
    <ActivityMultiUserChange
      addedUsers={addedWatchers}
      removedUsers={removedWatchers}
    />
  ) : (
    <MultiUserChangeActivityCard
      {...props}
      className="IssuesActivityLog__activity-card"
      addedUsers={addedWatchers}
      removedUsers={removedWatchers}
    />
  );
};
